import { EventsReducerState } from './types';
import moment from 'moment';

export const defaultState: EventsReducerState = {
  events: {},
  site_id: '',
  from: moment(),
  to: moment()
};
